import {isDuplicateValue} from "./ArrayUtil";

export const loadAssetPath = (fileName) => {
    return [process.env.REACT_APP_ASSET_ENDPOINT, fileName].join('/')
}

export const isPermitted = (state) => {
    return state.user?.userId && isDuplicateValue(state.user.permittedArtists, state.currentArtist.code)
}
